import { GoogleClient } from '@/SDK/google/google-client';
import { createSlice } from '@reduxjs/toolkit';






// Redux state types
export interface ReduxGoogleSessionRootState {
    google: {
        client: GoogleClient;
    };

}

const initialState = {
    client: null,
};

const google = createSlice({
    name: 'google',
    initialState,
    reducers: {
        setGoogleClient: (state, action) => {
            state.client = action.payload;

            // console.log("New Google Client Saved: ", action.payload);
        },
        clearGoogleClient: (state) => {

            state.client = null;

            console.log("Google Client Cleared");
        },
    },
});

export const { setGoogleClient, clearGoogleClient } = google.actions;
export default google.reducer;
